import { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  `tw-inline-flex tw-items-center tw-rounded-md tw-border tw-px-2.5 tw-py-0.5 
  tw-text-xs tw-transition-colors tw-leading-5
  tw-focus:outline-none tw-focus:ring-2 tw-focus:ring-ring tw-focus:ring-offset-2`,
  {
    variants: {
      variant: {
        default:
          'tw-border-transparent tw-bg-putty-light tw-text-black tw-shadow tw-hover:bg-putty-light/80',
        primary:
          'tw-border-transparent tw-bg-primary tw-text-primary-foreground tw-hover:bg-primary/80',
        secondary:
          'tw-border-transparent tw-bg-secondary tw-text-secondary-foreground tw-hover:bg-secondary/80',
        danger:
          'tw-border-transparent tw-bg-destructive tw-text-destructive-foreground tw-shadow tw-hover:bg-destructive/80',
        success:
          'tw-border-transparent tw-bg-success tw-text-success-foreground tw-shadow tw-hover:bg-success/80',
        warning:
          'tw-border-transparent tw-bg-warning tw-text-warning-foreground tw-shadow tw-hover:bg-warning/80',
        info: 'tw-border-transparent tw-bg-info tw-text-info-foreground tw-shadow tw-hover:bg-info/80',
        outline: 'tw-text-foreground',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type BadgeProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants>;

const Badge = ({ className, variant, ...props }: BadgeProps) => (
  <div className={cn(badgeVariants({ variant }), className)} {...props} />
);

export { Badge, badgeVariants };
